module.exports = __webpack_public_path__ + "static/media/WEBnegro_55.9d1584ad.png";